import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "2213.664 1252 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2215.664 1272q-.824 0-1.413-.588a1.93 1.93 0 0 1-.587-1.412v-11q0-.824.587-1.412a1.93 1.93 0 0 1 1.413-.588h5v-3q0-.824.587-1.412a1.93 1.93 0 0 1 1.413-.588h2q.824 0 1.412.588.588.587.588 1.412v3h5q.824 0 1.412.588.588.587.588 1.412v11q0 .824-.588 1.412a1.93 1.93 0 0 1-1.412.588zm0-2h16v-11h-5q0 .824-.588 1.412a1.93 1.93 0 0 1-1.412.588h-2q-.824 0-1.413-.588a1.93 1.93 0 0 1-.587-1.412h-5zm2-2h6v-.45q0-.425-.237-.788a1.57 1.57 0 0 0-.663-.562 5 5 0 0 0-1.013-.337 5 5 0 0 0-1.087-.113 5 5 0 0 0-1.088.113 5 5 0 0 0-1.012.337q-.425.2-.663.562a1.4 1.4 0 0 0-.237.788zm8-1.5h4v-1.5h-4zm-5-1.5q.624 0 1.063-.437.437-.438.437-1.063t-.437-1.062a1.45 1.45 0 0 0-1.063-.438q-.625 0-1.062.438a1.45 1.45 0 0 0-.438 1.062q0 .624.438 1.063.436.437 1.062.437m5-1.5h4v-1.5h-4zm-3-4.5h2v-5h-2zm1 5.5",
      class: "fills",
      style: {"fill":"#456332","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }